import Vue from 'vue';
// import mutations from './mutations'
// import actions from './actions'
import moment from 'moment';
import { Backend } from '@/_axios';

export const LOAD_PLANNED_WORKLOADS = 'LOAD_PLANNED_WORKLOADS';
export const LOAD_PROJECT_PLANNED_WORKLOADS = 'LOAD_PROJECT_PLANNED_WORKLOADS';
export const SET_PLANNED_WORKLOADS = 'SET_PLANNED_WORKLOADS';

export const UPDATE_PLANNED_WORKLOAD = 'UPDATE_PLANNED_WORKLOAD';
export const SET_PLANNED_WORKLOAD = 'SET_PLANNED_WORKLOAD';
export const DELETE_USERS_WORKLOADS_FROM_PROJECT = 'DELETE_USERS_WORKLOADS_FROM_PROJECT';
export const SET_WORKLOAD_DELETE_NOTIFICATION = 'SET_WORKLOAD_DELETE_NOTIFICATION';
export const DELETE_PLANNED_WORKLOAD = 'DELETE_PLANNED_WORKLOAD';

const state = {
  workloads: {},
  status: 'empty',
  loadedCallbacks: [],
  workloadNotification: {
    status: 'loading',
    data: {},
    message: ''
  }
};

const getters = {
  workloadsByProjectByUserByYearweek: (state) => {
    const workloads = {};
    for (const workloadId in state.workloads) {
      const rawPlan = state.workloads[workloadId];
      if (!workloads[rawPlan.project_id]) workloads[rawPlan.project_id] = {};

      if (!workloads[rawPlan.project_id][rawPlan.user_id]) workloads[rawPlan.project_id][rawPlan.user_id] = {};

      if (!workloads[rawPlan.project_id][rawPlan.user_id][rawPlan.yearweek]) workloads[rawPlan.project_id][rawPlan.user_id][rawPlan.yearweek] = [];

      workloads[rawPlan.project_id][rawPlan.user_id][rawPlan.yearweek].push(rawPlan);
    }
    return workloads;
  },
  workloadsByProjectByUserByMonth: (state) => {
    const workloads = {};
    for (const workloadId in state.workloads) {
      const rawPlan = state.workloads[workloadId];
      if (!workloads[rawPlan.project_id]) workloads[rawPlan.project_id] = {};

      if (!workloads[rawPlan.project_id][rawPlan.user_id]) workloads[rawPlan.project_id][rawPlan.user_id] = {};

      const month = `${rawPlan.year}${rawPlan.month >= 10 ? rawPlan.month : `0${rawPlan.month}`}`;

      if (!workloads[rawPlan.project_id][rawPlan.user_id][month]) workloads[rawPlan.project_id][rawPlan.user_id][month] = [];

      workloads[rawPlan.project_id][rawPlan.user_id][month].push(rawPlan);
    }
    return workloads;
  },
  workloadsByProjectByUserByQuarter: (state) => {
    const workloads = {};
    for (const workloadId in state.workloads) {
      const rawPlan = state.workloads[workloadId];
      if (!workloads[rawPlan.project_id]) workloads[rawPlan.project_id] = {};

      if (!workloads[rawPlan.project_id][rawPlan.user_id]) workloads[rawPlan.project_id][rawPlan.user_id] = {};

      const quarter = `${rawPlan.year}${rawPlan.quarter}`;

      if (!workloads[rawPlan.project_id][rawPlan.user_id][quarter]) workloads[rawPlan.project_id][rawPlan.user_id][quarter] = [];

      workloads[rawPlan.project_id][rawPlan.user_id][quarter].push(rawPlan);
    }
    return workloads;
  },
  workloadsByProjectByUserByYear: (state) => {
    const workloads = {};
    for (const workloadId in state.workloads) {
      const rawPlan = state.workloads[workloadId];
      if (!workloads[rawPlan.project_id]) workloads[rawPlan.project_id] = {};

      if (!workloads[rawPlan.project_id][rawPlan.user_id]) workloads[rawPlan.project_id][rawPlan.user_id] = {};

      const year = rawPlan.year;

      if (!workloads[rawPlan.project_id][rawPlan.user_id][year]) workloads[rawPlan.project_id][rawPlan.user_id][year] = [];

      workloads[rawPlan.project_id][rawPlan.user_id][year].push(rawPlan);
    }
    return workloads;
  },
  workloads: (state) => {
    return state.workloads;
  },
  workloadNotification: (state) => {
    return state.workloadNotification;
  },
  workloadsByUserByYearweekByProject: (state, getters, rootState, rootGetters) => {
    const workloads = {};
    const actualDateDay = new Date(rootGetters['Worklogs/actualDateDay']);
    const actualDate = rootGetters['Worklogs/actualDate'];

    for (const workloadId in state.workloads) {
      const workload = state.workloads[workloadId];
      const dateWorkloadObj = new Date(workload.date);

      if (!workloads[workload.user_id]) {
        workloads[workload.user_id] = {};
      }
      if (!workloads[workload.user_id][workload.yearweek]) {
        workloads[workload.user_id][workload.yearweek] = {
          totalPlanned: 0,
          totalCalculated: 0,
          totalExpenses: 0,
          projects: {},
          plannedTimeFromTodayTillPeriodEnd: 0,
        };
      }

      if (actualDateDay < dateWorkloadObj) {
        workloads[workload.user_id][workload.yearweek].plannedTimeFromTodayTillPeriodEnd += workload.planned_time;
      }

      workloads[workload.user_id][workload.yearweek].totalPlanned += workload.planned_time;
      workloads[workload.user_id][workload.yearweek].totalCalculated += workload.calculated_time;
      workloads[workload.user_id][workload.yearweek].totalExpenses += ((workload.calculated_time + workload.planned_time) * rootGetters['UserRates/ratesOnDate'](workload.date, workload.user_id));

      if (!workloads[workload.user_id][workload.yearweek].projects[workload.project_id]) {
        workloads[workload.user_id][workload.yearweek].projects[workload.project_id] = {
          plannedTime: 0,
          calculatedTime: 0,
          expenses: 0,
          plannedTimeFromTodayTillPeriodEnd: 0,
        };
      }

      if (actualDateDay < dateWorkloadObj) workloads[workload.user_id][workload.yearweek].projects[workload.project_id].plannedTimeFromTodayTillPeriodEnd += workload.planned_time;

      workloads[workload.user_id][workload.yearweek].projects[workload.project_id].plannedTime += workload.planned_time;
      workloads[workload.user_id][workload.yearweek].projects[workload.project_id].calculatedTime += workload.calculated_time;
      workloads[workload.user_id][workload.yearweek].projects[workload.project_id].expenses += ((workload.calculated_time + workload.planned_time) * rootGetters['UserRates/ratesOnDate'](workload.date, workload.user_id));
    }
    return workloads;
  },
  workloadsByUserByMonthByProject: (state, getters, rootState, rootGetters) => {
    const workloads = {};
    const actualDateDay = new Date(rootGetters['Worklogs/actualDateDay']);
    const actualDate = rootGetters['Worklogs/actualDate'];

    for (const workloadId in state.workloads) {
      const workload = state.workloads[workloadId];
      const dateWorkloadObj = Date.parse(workload.date);

      if (!workloads[workload.user_id]) workloads[workload.user_id] = {};

      const month = `${workload.year}${workload.month >= 10 ? workload.month : `0${workload.month}`}`;

      if (!workloads[workload.user_id][month]) {
        workloads[workload.user_id][month] = {
          totalPlanned: 0,
          totalCalculated: 0,
          projects: {},
          plannedTimeFromTodayTillPeriodEnd: 0,
        };
      }

      if (actualDateDay < dateWorkloadObj) workloads[workload.user_id][month].plannedTimeFromTodayTillPeriodEnd += workload.planned_time;

      workloads[workload.user_id][month].totalPlanned += workload.planned_time;
      workloads[workload.user_id][month].totalCalculated += workload.calculated_time;

      if (!workloads[workload.user_id][month].projects[workload.project_id]) {
        workloads[workload.user_id][month].projects[workload.project_id] = {
          plannedTime: 0,
          calculatedTime: 0,
          plannedTimeFromTodayTillPeriodEnd: 0,
        };
      }

      if (actualDateDay < dateWorkloadObj) workloads[workload.user_id][month].projects[workload.project_id].plannedTimeFromTodayTillPeriodEnd += workload.planned_time;

      workloads[workload.user_id][month].projects[workload.project_id].plannedTime += workload.planned_time;
      workloads[workload.user_id][month].projects[workload.project_id].calculatedTime += workload.calculated_time;
    }
    return workloads;
  },
  workloadsByUserByQuarterByProject: (state, getters, rootState, rootGetters) => {
    const workloads = {};
    const actualDateDay = new Date(rootGetters['Worklogs/actualDateDay']);
    const actualDate = rootGetters['Worklogs/actualDate'];

    for (const workloadId in state.workloads) {
      const workload = state.workloads[workloadId];
      const dateWorkloadObj = Date.parse(workload.date);

      if (!workloads[workload.user_id]) workloads[workload.user_id] = {};

      const quarter = `${workload.year}${workload.quarter}`;

      if (!workloads[workload.user_id][quarter]) {
        workloads[workload.user_id][quarter] = {
          totalPlanned: 0,
          totalCalculated: 0,
          projects: {},
          plannedTimeFromTodayTillPeriodEnd: 0
        };
      }

      if (actualDateDay < dateWorkloadObj) workloads[workload.user_id][quarter].plannedTimeFromTodayTillPeriodEnd += workload.planned_time;

      workloads[workload.user_id][quarter].totalPlanned += workload.planned_time;
      workloads[workload.user_id][quarter].totalCalculated += workload.calculated_time;

      if (!workloads[workload.user_id][quarter].projects[workload.project_id]) {
        workloads[workload.user_id][quarter].projects[workload.project_id] = {
          plannedTime: 0,
          calculatedTime: 0,
          plannedTimeFromTodayTillPeriodEnd: 0
        };
      }

      if (actualDateDay < dateWorkloadObj) workloads[workload.user_id][quarter].projects[workload.project_id].plannedTimeFromTodayTillPeriodEnd += workload.planned_time;

      workloads[workload.user_id][quarter].projects[workload.project_id].plannedTime += workload.planned_time;
      workloads[workload.user_id][quarter].projects[workload.project_id].calculatedTime += workload.calculated_time;
    }
    return workloads;
  },
  workloadsByUserByYearByProject: (state, getters, rootState, rootGetters) => {
    const workloads = {};
    const actualDateDay = new Date(rootGetters['Worklogs/actualDateDay']);
    const actualDate = rootGetters['Worklogs/actualDate'];

    for (const workloadId in state.workloads) {
      const workload = state.workloads[workloadId];
      const dateWorkloadObj = Date.parse(workload.date);

      if (!workloads[workload.user_id]) workloads[workload.user_id] = {};

      const year = workload.year;

      if (!workloads[workload.user_id][year]) {
        workloads[workload.user_id][year] = {
          totalPlanned: 0,
          totalCalculated: 0,
          projects: {},
          plannedTimeFromTodayTillPeriodEnd: 0
        };
      }

      if (actualDateDay < dateWorkloadObj) workloads[workload.user_id][year].plannedTimeFromTodayTillPeriodEnd += workload.planned_time;

      workloads[workload.user_id][year].totalPlanned += workload.planned_time;
      workloads[workload.user_id][year].totalCalculated += workload.calculated_time;

      if (!workloads[workload.user_id][year].projects[workload.project_id]) {
        workloads[workload.user_id][year].projects[workload.project_id] = {
          plannedTime: 0,
          calculatedTime: 0,
          plannedTimeFromTodayTillPeriodEnd: 0
        };
      }

      if (actualDateDay < dateWorkloadObj) workloads[workload.user_id][year].projects[workload.project_id].plannedTimeFromTodayTillPeriodEnd += workload.planned_time;

      workloads[workload.user_id][year].projects[workload.project_id].totalPlanned += workload.planned_time;
      workloads[workload.user_id][year].projects[workload.project_id].totalCalculated += workload.calculated_time;
    }
    return workloads;
  },
  workloadsByProjectByYearweekByUser: (state) => {
    const workloads = {};
    for (const workloadId in state.workloads) {
      const rawPlan = state.workloads[workloadId];
      if (!workloads[rawPlan.project_id]) workloads[rawPlan.project_id] = {};

      if (!workloads[rawPlan.project_id][rawPlan.yearweek]) workloads[rawPlan.project_id][rawPlan.yearweek] = {};

      if (!workloads[rawPlan.project_id][rawPlan.yearweek][rawPlan.user_id]) workloads[rawPlan.project_id][rawPlan.yearweek][rawPlan.user_id] = { date: rawPlan.date, planned_time: 0 };

      workloads[rawPlan.project_id][rawPlan.yearweek][rawPlan.user_id].planned_time += rawPlan.planned_time;
    }
    return workloads;
  }
};

const actions = {
  [LOAD_PLANNED_WORKLOADS]: function ({ commit, state }, callback = null) {
    // if(typeof callback === 'function'){
    //     if(state.status === 'done') {
    //         callback(state.workloads);
    //         return;
    //     }
    //     else state.loadedCallbacks.push(callback);
    // }
    // if(state.status === 'empty'){
    //     state.status = 'loading';
    Backend.get('/api/planned-workloads').then((response) => {
      const plannedWorkloads = {};
      response.data.forEach((plannedWorkload) => {
        plannedWorkloads[plannedWorkload.id] = plannedWorkload;
      });
      commit('SET_PLANNED_WORKLOADS', plannedWorkloads);
    });
    // }
  },
  [LOAD_PROJECT_PLANNED_WORKLOADS]: function ({ commit, state }, { id }, callback = null) {
    // if(typeof callback === 'function'){
    //     if(state.status === 'done') {
    //         callback(state.workloads);
    //         return;
    //     }
    //     else state.loadedCallbacks.push(callback);
    // }
    // if(state.status === 'empty'){
    //     state.status = 'loading';
    Backend.get('/api/project-planned-workloads', { params: { project_id: id } }).then((response) => {
      const plannedWorkloads = {};
      response.data.forEach((plannedWorkload) => {
        plannedWorkloads[plannedWorkload.id] = plannedWorkload;
      });
      commit('SET_PLANNED_WORKLOADS', plannedWorkloads);
    });
    // }
  },
  [UPDATE_PLANNED_WORKLOAD]: function ({ commit }, { plannedSeconds, user_id, project_id, date, uid }) {
    Backend.post('/api/planned-workload', { planned_seconds: plannedSeconds, user_id: user_id, project_id: project_id, date: date }).then((response) => {
      if (response.data.status == 'updated') {
        commit('SET_PLANNED_WORKLOAD', { workloads: response.data.data, uid: uid });
      } else {
        commit('DELETE_PLANNED_WORKLOAD', { deleted: response.data.data, uid: uid });
      }
    });
  },
  [DELETE_USERS_WORKLOADS_FROM_PROJECT]: function ({ commit }, { userId, projectId }) {
    Backend.post('/api/delete-user-workloads-from-project', { user_id: userId, project_id: projectId }).then((response) => {
      commit('SET_WORKLOAD_DELETE_NOTIFICATION', { message: response.data.data.message, status: 'success' });
    }, (err) => {
      // console.log(err.response);
      commit('SET_WORKLOAD_DELETE_NOTIFICATION', { message: err.response.data.data.message, status: 'error' });
    });
  }
};

const mutations = {
  [SET_PLANNED_WORKLOADS]: function (state, workloads) {
    Vue.set(state, 'workloads', workloads);
    // state.status="done";
    // state.loadedCallbacks.forEach(callback => {
    //     if(typeof callback === 'function'){
    //         callback(workloads);
    //     }
    // });
  },
  [SET_PLANNED_WORKLOAD]: function (state, data) {
    // console.log(state.workloads);
    data.workloads.forEach((workload) => {
      Vue.set(state.workloads, workload.id, workload);
    });
    EventBus.$emit(`update-planned-workload-${data.uid}`);
  },
  [SET_WORKLOAD_DELETE_NOTIFICATION]: function (state, { message, status }) {
    state.workloadNotification = {
      status: status,
      data: {},
      message: message
    };
  },
  [DELETE_PLANNED_WORKLOAD]: function (state, data) {
    for (const i in data.deleted) {
      Vue.delete(state.workloads, data.deleted[i]);
    }
    EventBus.$emit(`update-planned-workload-${data.uid}`);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
